import React from 'react'

const Locked = () => {
    return (
        <i class="fas fa-lock" onClick={e=>document.getElementById('Login_to_view_button').click()}></i>
    )
}


export default Locked
